import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/core/models/api-response';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { IdName } from '../../shared/models/id-name';
import { ICompetenceModel } from '../model/competence.model';

@Injectable({
  providedIn: 'root',
})
export class CompetenceApiService {
  private get baseUrl(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/Competence`;
  }

  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  getCompetences(
    isInUse: boolean,
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<ICompetenceModel[]>> {
    let params = createFilterParams(currentFilter);
    params = params.set('includeNotInUse', isInUse);

    return this.http.get<ApiResponse<ICompetenceModel[]>>(this.baseUrl, {
      ...this.httpOptions,
      params,
    });
  }

  getDepartmentsRelatedCompetences(
    departmentIds: string[] = [],
    departmentGroupIds: string[] = []
  ): Observable<IdName[]> {
    const url = `${this.baseUrl}/DepartmentsRelated`;
    return this.http.get<IdName[]>(url, { params: { departmentIds, departmentGroupIds } });
  }

  getAllCompetences(): Observable<IdName[]> {
    const url = `${this.baseUrl}/List`;
    return this.http.get<IdName[]>(url, this.httpOptions);
  }

  addCompetence(competence: ICompetenceModel): Observable<ICompetenceModel> {
    const url = `${this.baseUrl}`;
    return this.http.post<ICompetenceModel>(url, competence, this.httpOptions);
  }

  getCompetenceById(id: string): Observable<ICompetenceModel> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<ICompetenceModel>(url, this.httpOptions);
  }

  updateCompetence(competence: ICompetenceModel): Observable<void> {
    const url = `${this.baseUrl}/${competence.id}`;
    return this.http.put<void>(url, competence, this.httpOptions);
  }

  deleteCompetence(id: string): Observable<void> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.delete<void>(url, this.httpOptions);
  }
}
